import { Card, CardContent, Grid } from "@mui/material";
import MDTypography from "components/MDTypography";

export function MDNoSelectedClient({ wasWanted, isCase, isIndice }) {
    return (
        <Card className="card-stats" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <CardContent style={{ paddingTop: 126, paddingBottom: 126 }}>
                <Grid item xs={10} >
                    <div className="numbers">
                        <MDTypography variant="h5" className="card-title">
                            {wasWanted ? "Sem informações disponíveis" : `${isCase ? `Nenhum ${!isIndice ? ' cliente ' : ' índice '} selecionado` : "Nenhuma empresa selecionada"}`}
                        </MDTypography>
                        <MDTypography variant="body2" style={{ marginTop: 10 }}>
                            {wasWanted ? `${isCase ? `O ${!isIndice ? ' cliente ' : ' índice '} selecionado` : "A empresa selecionada"} não possui dados para que possamos demonstrar essa tela.` :
                                ` É necessário selecionar ${isCase ? ` um ${!isIndice ? ' cliente ' : ' índice '}` : " uma empresa"} para visualizar os dados.`}
                        </MDTypography>
                    </div>
                </Grid>
            </CardContent>
        </Card>
    )
}